import { selectorFamily } from 'recoil';

import ordersAtom from '~/recoil/atom/orders';
import cartTypeAtom from '~/recoil/atom/cartType';

import * as fp from 'lodash/fp';
import { CartType, StoreOrderInCart } from '~/types/cart';
import enterpriseGroupBuyOrdersAtom from '../atom/enterpriseGroupBuy/enterpriseGroupBuyOrders';
import globalEnterpriseGroupBuyAtom from '../atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';

const cartOptionCount = selectorFamily<Map<string, number>, { storeId: string }>({
  key: 'cartOptionsCount',
  get:
    ({ storeId }) =>
    ({ get }) => {
      const cartType: CartType = get(cartTypeAtom);
      const { data = null } = get(globalEnterpriseGroupBuyAtom);
      const orders: Array<StoreOrderInCart> = get(
        !!data ? enterpriseGroupBuyOrdersAtom : ordersAtom,
      );

      const storeOrder = orders.find(fp.propEq('storeId', storeId));
      const orderItems = fp.eq(cartType, CartType.CART_GROUP)
        ? (storeOrder?.groupItems || []).flatMap(fp.propOr([], 'items'))
        : storeOrder?.items || [];

      return orderItems.reduce<Map<string, number>>((acc, { count, modifiers }) => {
        const options = modifiers.flatMap(({ id, options }) =>
          options.map((option) => `${id}_${option.id}`),
        );

        options.forEach((id) => {
          const optionCount = acc.get(id) || 0;
          acc.set(id, optionCount + count);
        });

        return acc;
      }, new Map());
    },
});

export default cartOptionCount;
